import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { Departmentdivisionlist } from '../../../interface/delegationofauthority/departmentdivisionlist';
import { DelegationofauthorityService } from '../../../services/delegationofauthority/delegationofauthority.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IDepartments } from '../../../interface/delegationofauthority/searchdoa';
import { MatPaginator, MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { Router } from '@angular/router';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Overlay } from '@angular/cdk/overlay';
import { DisplaypageComponent } from '../displaypage/displaypage.component';
import { IDivisions } from '../../../interface/delegationofauthority/searchdoa';
import { SharedServices } from '../../../shared/services/shared.services';

@Component({
  selector: 'app-bydepartmentdivision',
  imports: [CommonModule, FormsModule, MatPaginatorModule, MatTableModule, MatProgressSpinner],
  templateUrl: './bydepartmentdivision.component.html',
  styleUrl: './bydepartmentdivision.component.css'
})
export class BydepartmentdivisionComponent implements OnInit, AfterViewInit {
  departments: IDepartments[] = [];
  showFields: boolean = false;
  employees: Departmentdivisionlist[] = [];
  filteredDepartments: IDepartments[] = [];
  filteredDivisions: IDivisions[] = [];
  isLoading: boolean = false;
  filteredEmployees = new MatTableDataSource<Departmentdivisionlist>([]);
  selectedDepartment: string = '';
  selectedDivision: string = '';
  selectedOrder: string = 'name';
  error: string | null = null;
  displayedColumns: string[] = ['sno', 'fullName', 'jobTitle', 'deptName', 'divisionName', 'sectionName'];

  @ViewChild(MatPaginator) paginator!: MatPaginator;

  constructor(
    private delegationService: DelegationofauthorityService,
    private dialog: MatDialog,
    private overlay: Overlay,
   private sharedService: SharedServices,
  ) { }

  ngOnInit(): void {
    this.dropdownValues();
  }

  ngAfterViewInit(): void {
    this.filteredEmployees.paginator = this.paginator;
  }

  navigateToDisplayPage(employeeNo: string): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '99%';
    dialogConfig.height = '99%';
    dialogConfig.data = { employeeNo };

    const dialogRef = this.dialog.open(DisplaypageComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
    });
  }

  dropdownValues() {
    this.delegationService.getDepartmentsFromcloudService().subscribe(
      (data: any) => {
        const depts = data.value; 
        if (Array.isArray(depts)) {
          this.filteredDepartments = depts.filter((department: IDepartments) => 
            department && 
            department.id && 
            department.deptName && 
            department.deptName.trim().length > 0
          );
          this.filteredDepartments.unshift({ id: 'all', deptCode: 'all', deptName: 'All' });
          if (this.filteredDepartments.length > 0) {
            this.selectedDepartment = this.filteredDepartments[0].id;
            this.fetchDivisions(this.selectedDepartment);
          }
        } else {
          console.error('Expected an array but got:', depts);
        }
      },
      (error) => {
        console.error('Error fetching departments:', error);
      }
    );
  }
  fetchDivisions(id: string): void {
    this.delegationService.getSepficDivisionsFromcloudService(id).subscribe(
        (response: any) => {
            const divisions = response.value;
            if (Array.isArray(divisions)) {
                this.filteredDivisions = divisions.filter((division: IDivisions) =>
                    division &&
                    division.id &&
                    division.divisionName &&
                    division.divisionName.trim().length > 0
                );
                this.filteredDivisions.unshift({ id: 'all', deptID: '', divisionName: 'All', divisionHead: '' });
            }
        },
        (error) => {
            console.error('Error fetching Divisions', error);
        }
    );
}

  onSubmit(): void {
    if (!this.selectedDivision) {
      this.sharedService.openModal('Message', 'Please select a division.');
      return;
    }
    this.isLoading = true;
    this.showFields = true;
    this.employees = [];
    this.filteredEmployees.data = [];
    this.error = null;
  
    this.delegationService.getDepartmentDivisionDetails(this.selectedDepartment, this.selectedDivision, this.selectedOrder)
      .subscribe((data: Departmentdivisionlist[]) => {
        this.employees = data;
        this.filteredEmployees.data = data;
        this.filteredEmployees.paginator = this.paginator;
        this.isLoading = false;
      }, error => {
        this.isLoading = false;
        this.showFields = true;
        this.error = 'No employee found!';
        this.filteredEmployees.data = [];
      });
  }

  downloadWorksheet(): void {
    this.delegationService.getDepartmentDivisionWorksheet(this.selectedDepartment, this.selectedDivision, this.selectedOrder)
      .subscribe(blob => {
        const a = document.createElement('a');
        const objectUrl = URL.createObjectURL(blob);
        a.href = objectUrl;
        a.download = `DepartmentDivisionWorksheet_${new Date().toISOString().slice(0, 19).replace(/:/g, '-')}.xlsx`;
        a.click();
        URL.revokeObjectURL(objectUrl);
      }, error => {
        this.error = 'Failed to download the worksheet!';
      });
  }
   get selectedDepartmentName(): string {
    const selectedDept = this.filteredDepartments.find(dept => dept.id === this.selectedDepartment);
    return selectedDept ? selectedDept.deptName : '';
  }

  get selectedDivisionName(): string {
    const selectedDept = this.filteredDivisions.find(division => division.id === this.selectedDivision);
    return selectedDept ? selectedDept.divisionName : '';
  }

}